import { upperFirst } from 'lodash';

export function capitalizeObjectKeys<T>(obj: T): T {
  return Object.fromEntries(Object.entries(obj).map(([key, value]) => [upperFirst(key), value])) as T;
}
